module.exports = __webpack_public_path__ + "img/ic_contentitem_challenge.6fda1866.svg";